import { ConfirmingButton } from "./ConfirmingButton";

type Props = {
  onDelete: () => Promise<unknown>;
  itemName: string;
  disabled?: boolean;
};

export function DeleteConfirmation({
  onDelete,
  itemName,
  disabled = false,
}: Props) {
  return (
    <ConfirmingButton
      onConfirm={onDelete}
      confirmContent="Delete?"
      disabled={disabled}
    >
      Delete {itemName}
    </ConfirmingButton>
  );
}
